import { ActionSource } from 'owa-mail-store';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';

export default {
    resetFocusedOtherRollup: {
        name: 'TnS_ResetFocusedOtherRollup',
        customData: (focusedViewFilter: FocusedViewFilter, actionSource: ActionSource) => [
            actionSource,
            focusedViewFilter,
        ],
    },
};
